// Lista maestra de productos. Editar SOLO aquí para agregar/quitar productos.

const CALIENTES = [
  { clave: '1',   nombre: 'Pechuga',   short: 'PE',  icon: '🍗', allowHalf: true,  factor: 1 },
  { clave: '2',   nombre: 'Pierna',    short: 'PI',  icon: '🦵', allowHalf: true,  factor: 2 },
  { clave: '3.1', nombre: 'Ala',       short: 'AL',  icon: '🦴', allowHalf: false, factor: 2 },
  { clave: '3.2', nombre: 'Huacal',    short: 'HU',  icon: '📦', allowHalf: false, factor: 1 },
  { clave: '4',   nombre: 'Rabadilla', short: 'RA',  icon: '🍖', allowHalf: false, factor: 1 },
  { clave: '5',   nombre: 'Hígado',    short: 'HI',  icon: '🫀', allowHalf: false, factor: 1 },
  { clave: '6',   nombre: 'Patas',     short: 'PA',  icon: '🦶', allowHalf: false, factor: 2 },
  { clave: '7',   nombre: 'Cabeza',    short: 'CA',  icon: '🐔', allowHalf: false, factor: 1 },
];

const POLLO_ENTERO = { clave: '8', nombre: 'Pollo entero', short: 'PO', icon: '🍗', allowHalf: false, factor: null };

const FRIOS = [
  { clave: '1.1', nombre: 'Pechuga fría', short: 'PEF', icon: '🧊', allowHalf: true,  factor: 1 },
  { clave: '2.1', nombre: 'Pierna fría',  short: 'PIF', icon: '🧊', allowHalf: true,  factor: 2 },
  { clave: '3.3', nombre: 'Ala fría',     short: 'ALF', icon: '🧊', allowHalf: false, factor: 2 },
];

// Mapeo caliente → frío y conjunto de claves frías (para filtrar en la UI)
export const MAPA_A_FRIO = { '1': '1.1', '2': '2.1', '3.1': '3.3' };
export const CLAVES_FRIAS = new Set(Object.values(MAPA_A_FRIO));
export const PRODUCTOS_FRIOS = FRIOS;

// Lista completa: calientes → Pollo entero → fríos
export const PRODUCTOS = [...CALIENTES, POLLO_ENTERO, ...FRIOS];

// Sin Pollo Entero: calientes → fríos (para listas de precios, traslados, etc.)
export const PRODUCTOS_SIN_POLLO = [...CALIENTES, ...FRIOS];

// Para AdminListasPrecios
export const PRODUCTOS_LISTA_PRECIOS = PRODUCTOS_SIN_POLLO.map(({ clave, nombre }) => ({ clave, nombre }));

// Para AdminInventarioDashboard (compacto con código corto)
export const PIEZAS = PRODUCTOS_SIN_POLLO.map(({ clave, short }) => ({ clave, short }));

// Para TrasladosPOS
export const PIEZAS_TRASLADO = PRODUCTOS_SIN_POLLO.map(({ clave, short, nombre, allowHalf }) => ({
  clave, short, nombre, ...(allowHalf ? { allowHalf } : {}),
}));

// Para AdminInventarioDashboard — etiquetas de precio
export const PRECIO_LABELS = Object.fromEntries(PRODUCTOS_SIN_POLLO.map(p => [p.clave, p.nombre]));

// Para InventarioInicial y AdminAsignaciones — SOLO calientes (fríos los gestiona el propietario)
export const CONVERSION = Object.fromEntries(
  CALIENTES.map(p => [p.clave, { nombre: p.nombre, factor: p.factor }])
);

// Para AdminListasPrecios — piezas por pollo entero (EXCLUYE fríos)
export const FACTORES_POLLO = Object.fromEntries(
  CALIENTES.map(p => [p.clave, p.factor])
);
